import HttpClientWithRetry from '../http/client/HttpClientWithRetry';
import {
  UploadVirtualBackgroundResponse,
  VideoEffectPreExistingImages,
  VideoEffectPreferences,
  VideoEffectPreferencesPayload,
} from '../modules/meet/videoEffects/videoEffectTypes';

export class VideoController {
  constructor(private readonly httpClient: HttpClientWithRetry) {}

  async fetchPreferences({ participantId }: { participantId: string }) {
    const encodedParticipantId = encodeURIComponent(participantId);
    const path = `api/v1/participants/${encodedParticipantId}/preferences`;

    return this.httpClient.get<VideoEffectPreferences>(path);
  }

  async fetchVitualBackgrounds() {
    const path = `api/v1/participants/pre-existing-images`;
    return this.httpClient.get<VideoEffectPreExistingImages>(path);
  }

  async savePreferences({ participantId, preferences }: { participantId: string; preferences: VideoEffectPreferencesPayload }) {
    const encodedParticipantId = encodeURIComponent(participantId);
    const path = `api/v1/participants/${encodedParticipantId}/preferences`;
    return this.httpClient.put(path, preferences);
  }

  async uploadBackgroundImage(participantId: string, data: FormData) {
    const encodedParticipantId = encodeURIComponent(participantId);
    const path = `api/v1/participants/${encodedParticipantId}/preferences/background-images`;
    return this.httpClient.post<UploadVirtualBackgroundResponse>(path, data);
  }

  async deleteBackgroundImage(participantId: string, imageId: string) {
    const encodedParticipantId = encodeURIComponent(participantId);
    const path = `api/v1/participants/${encodedParticipantId}/preferences/background-images/${imageId}`;
    return this.httpClient.delete<UploadVirtualBackgroundResponse>(path);
  }
}
